import { makeStyles } from "tss-react/mui";
import { mdiChevronDown } from "@mdi/js";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";

/**
 * Renders a custom accordion component displaying grouped data.
 * @param {Object} props
 * @param {Object} props.groupedData
 * @param {Function} props.renderDetails
 * @param {boolean} props.hideExpand
 * @returns {JSX.Element}
 */

export function MiAccordion({
  groupedData = [],
  renderDetails = () => null,
  renderSummary = () => null,
  hideExpand = false,
}) {
  const { classes } = useStyles();

  return groupedData.map((data) => (
    <Accordion
      key={data.id}
      disableGutters
      elevation={0}
      sx={{
        "&:before": {
          display: "none",
        },
      }}
      classes={{
        rounded: classes.accordion,
        root: classes.root,
      }}
    >
      <AccordionSummary
        expandIcon={!hideExpand && <MiIcon path={mdiChevronDown} />}
        classes={{
          root: classes.accordionSummary,
          content: classes.accordionContent,
        }}
      >
        {renderSummary(data)}
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.accordionDetails }}>
        {renderDetails(data.data)}
      </AccordionDetails>
    </Accordion>
  ));
}

const useStyles = makeStyles()((theme) => ({
  accordion: {
    borderTopRightRadius: "0px !important",
    borderBottomRightRadius: "0px !important",
  },
  root: {
    backgroundColor: theme.palette.grey.lightAccent,
    "&.Mui-expanded": {
      backgroundColor: theme.palette.grey.light,
    },
  },
  accordionContent: {
    margin: theme.spacing(1, 0),
  },
  accordionSummary: {
    minHeight: 0,
  },
  accordionDetails: {
    padding: 0,
  },
}));
